module.exports = __webpack_public_path__ + "media/images/pc/top/recommend-plan-maedori3-5dee26f44c212417878d4241bbb6708c.jpg";